var render = function render(){
  var _class;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.skeletonContainer] = true, _class[_vm.$style.darkTheme] = _vm.theme === 'dark', _class[_vm.$style.lightGrayTheme] = _vm.theme === 'lightGray', _class)
  });

}
var staticRenderFns = []

export { render, staticRenderFns }